/**
 * APPLY_TEMPLATES — "Apply recommendation" presets wired to Insights &
 * Analytics deep-links into Plan Wave.
 *
 * Insights & Analytics deep-links to /build-wave with URL params like:
 *   /build-wave?apply=duplicate&source=w2
 *   /build-wave?apply=refilter-tier&tier=micro
 *   /build-wave?apply=platform-mix&emphasis=instagram
 *   /build-wave?apply=sleep-niche
 *   /build-wave?apply=tighten-burst
 *
 * BuildWavePage reads `?apply=` once on mount, looks up this table, and
 * pre-fills the wizard state + shows a banner explaining which
 * recommendation was just applied.
 *
 * Extracted from BuildWavePage.js so the page orchestrator stays focused
 * on routing + state management. Adding a new "apply" key is a one-file
 * change.
 */

export const APPLY_TEMPLATES = {
  duplicate: {
    waveType: 'Branding',
    campaignName: 'Morning Ritual Wave — Round 2',
    campaignGoal: 'Awareness',
    budget: '300000',
    platforms: ['TikTok', 'Instagram', 'YouTube'],
    banner: {
      title: 'Duplicating: Morning Ritual Wave',
      body: "Your top performer (9.1x velocity, 96 pulse, 7.4x ROAS). We've pre-filled a matching brief — tweak anything you want before hitting Launch.",
      tone: 'teal',
    },
  },
  'refilter-tier': {
    banner: {
      title: 'Cohort re-filtered to Micro (10–50K followers)',
      body: 'Insights identified this tier as 2.4× higher ROAS than the Mid tier. Head to Step 2 (Creators) — we’ve pre-selected micro-tier creators.',
      tone: 'pink',
    },
  },
  'platform-mix': {
    waveType: 'Performance',
    platforms: ['Instagram', 'TikTok', 'YouTube'],
    campaignGoal: 'Conversion',
    banner: {
      title: 'Platform mix optimised for conversion',
      body: 'Instagram is ordered first (driving 54% of conversions) while TikTok still drives reach. Creative hooks will be tailored per platform automatically.',
      tone: 'teal',
    },
  },
  'sleep-niche': {
    waveType: 'Branding',
    campaignName: 'Sleep-Niche Engagement Wave',
    campaignGoal: 'Community-building',
    platforms: ['TikTok', 'Instagram'],
    banner: {
      title: 'Targeting sleep-niche creators',
      body: '3.1× higher comment-to-view ratio than fitness-niche. Step 2 will emphasise this niche in the cohort-generation brief.',
      tone: 'pink',
    },
  },
  'tighten-burst': {
    banner: {
      title: 'Burst window tightened to ±3 min',
      body: 'Shows 18% higher algorithmic lift than ±5 min. The Wave Orchestrator will use the tighter window on this wave automatically.',
      tone: 'teal',
    },
  },
};
